
import { useEffect } from 'react'
import Select from 'react-select'
import { DepartmentDDLAPI, EmployeeDDLAPI, JunctionNameDDLAPI, LocationNameDDLAPI, PipelineDDLAPI, SectorDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const PipelineDataDDL = (props) => {
    const { Pipeline, setPipeline, JunctionNameDDL, PopUpField, IsPost, WardName, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            M_WS_JunctionID: JunctionNameDDL.ID,
            DashProjectTypeId: DashProjectTypeId,
            M_Distri_WS_LocationID: JunctionNameDDL.ID,
            RoleID: RoleID
        }
        dispatch(PipelineDDLAPI({ data }))
    }, [IsPost, JunctionNameDDL.ID])

    const { PipelineData } = useSelector(state => state.PipelineDDLData)

    useEffect(() => {
        handlePipelineDDL()
    }, [PipelineData])

    const handlePipelineDDL = () => {
        // console.log(DeptDDLDataa)
        if (PipelineData && PipelineData.table && PipelineData.table.length > 0) {
            if (DashProjectTypeId == 6 && RoleID != '16') {
                let list = PipelineData.table.map((item, index) => ({
                    value: item.m_Distri_WS_PipeLineID,
                    label: item.pipelineDetails,
                }))
                setPipeline({
                    DDL: list,
                    ID: 0,
                    Label: "Select...",
                })
            } else {
                let list = PipelineData.table.map((item, index) => ({
                    value: item.m_wS_PipeLineID,
                    label: item.pipelineDetails,
                }))
                setPipeline({
                    DDL: list,
                    ID: 0,
                    Label: "Select...",
                })
            }


        }
        else {
            setPipeline({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Pipeline </b></label>
            <Select
                isSearchable
                isClearable
                maxMenuHeight={150}
                value={{ value: Pipeline.ID, label: Pipeline.Label }}
                onChange={(e) => {
                    e ?
                        setPipeline({ ...Pipeline, ID: e.value, Label: e.label })
                        :
                        setPipeline({ ...Pipeline, ID: 0, Label: "Select..." })

                }}
                options={Pipeline.DDL}
            />
        </div>
    )
}